/* eslint-disable import/prefer-default-export */
import {
    IEC_61508_1998,
    IEC_61508_2010,
    IEC_61511_2003,
    IEC_61511_2016,
} from "const"
import { SilResultSubsystem } from "server/models"
import { SilTarget } from "client/utils"
import { LangType } from "client/store"

import * as Formulas from ".."

export const diversitySilSubsystem = (
    subsystem: SilResultSubsystem,
    lang: LangType,
) => {
    let silDeviceHighest = 0
    let notCompliant = false

    subsystem.blocks.forEach((block) => {
        // if any of the devices is "Not Compliant" then subsystem is "Not Compliant"
        if (notCompliant) return

        // determine SIL for each device
        const { projectDevice } = block
        const {
            sil,
            type,
            failureRate,
            provenInUse,
            logicSolver,
            sd,
            su,
            dd,
            du,
        } = projectDevice
        const mode = Formulas.getSilMode(projectDevice)

        const sff = failureRate
            ? Formulas.sff({ su, sd, du, dd })
            : Formulas.parseProp(projectDevice.sff)

        const dc = failureRate
            ? Formulas.dc({ dd, du })
            : Formulas.parseProp(projectDevice.dc)

        // define SIL Architecture on device level
        let silDevice: string | JSX.Element
        if (sil) {
            silDevice = lang[`sil_${sil}`]
        } else {
            const { architecturalConstraints } = subsystem
            if (architecturalConstraints === IEC_61508_2010) {
                silDevice = Formulas.iec_61508_2010_device({ type, mode, provenInUse, sff, dc, lang, silOnly: true })
            }
            if (architecturalConstraints === IEC_61508_1998) {
                silDevice = Formulas.iec_61508_1998_device({ type, sff, lang, silOnly: true })
            }
            if (architecturalConstraints === IEC_61511_2016) {
                silDevice = Formulas.iec_61511_2016_device({ type, mode, provenInUse, dc, lang, silOnly: true })
            }
            if (architecturalConstraints === IEC_61511_2003) {
                silDevice = Formulas.iec_61511_2003_device({ provenInUse, logicSolver, sff, lang, silOnly: true })
            }
        }

        // "0" if "Not Compliant" or "Insufficient Data"
        const silDeviceParsed = Formulas.parseSilValue(silDevice as string, lang)

        // if any of the devices is "Not Compliant" then subsystem is "Not Compliant"
        if (silDeviceParsed === 0) {
            notCompliant = true
            return
        }

        // select the highest SIL Architecture on device level
        if (silDeviceParsed > silDeviceHighest) {
            silDeviceHighest = silDeviceParsed
        }
    })

    if (notCompliant) return lang.notCompliant

    const hft = Formulas.getHFT(subsystem.architecture)
    let silSubsystem = silDeviceHighest + hft
    if (silSubsystem > 4) silSubsystem = 4
    return lang[`sil_${silSubsystem as SilTarget}`]
}
